import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'epione.net Onboarding';

  constructor(
    route: ActivatedRoute,
    router: Router
  ) {
    /**
     * NB: This is a workaround for angular loosing query params on load with:
     * { pathMatch: 'full', redirectTo: 'main' }
     * inside the routing, if fails to keep query param on init.
     * 
     * This way we are grabbing them manually and forcing the token param into the redirect
    */
    const params = new URLSearchParams(window.location.href.split('?')[1]);
    let redirect = ['onboarding'];

    router.navigate(redirect, {
      queryParamsHandling: 'merge',
      queryParams: {
        ...route.snapshot.queryParams,
        ...[...params.entries()].reduce((o, [k, v]) => ({ ...o, [k]: v }), {})
      }
    });
  }
}
